import { c as _c } from "react/compiler-runtime";
import { Divider, FontWeights } from "@flat-ui";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { useAppSelector } from "@store/store-helper";
import { tableTypeSelector } from "@store/table/table-selector";

/** The clear all filter button and its functionality */
export function FilterToolbarClearAll() {
  const $ = _c(11);
  const {
    isAnyFilterApplied,
    clearAllFilters
  } = useFilterQueryParams();
  const tableType = useAppSelector(tableTypeSelector);
  if (!isAnyFilterApplied) {
    return null;
  }
  let t0;
  if ($[0] !== clearAllFilters || $[1] !== tableType) {
    t0 = function onClearClicked() {
      if (tableType !== null) {
        clearAllFilters(tableType);
      }
    };
    $[0] = clearAllFilters;
    $[1] = tableType;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onClearClicked = t0;
  let t1;
  if ($[3] !== isAnyFilterApplied) {
    t1 = isAnyFilterApplied && <Divider orientation="vertical" />;
    $[3] = isAnyFilterApplied;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontWeight: FontWeights.SemiBold
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onClearClicked) {
    t3 = <FaroTextButton onClick={onClearClicked} tooltipText="Clear all filters" sx={t2}>Clear filters</FaroTextButton>;
    $[6] = onClearClicked;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}